import { ChartDetails } from '../../types'
import { ChartTabsPanel, createChartTab } from '@/ui/charts/components/ChartTabsPanel'
import { TotalStakedChart } from '@/ui/charts/total-staked-chart/TotalStakedChart'
import { cn } from '@/ui/utils/style'

export interface ChartsPanelProps {
  chartDetails: ChartDetails
}

export function ChartsPanel({ chartDetails }: ChartsPanelProps) {
  return (
    <ChartTabsPanel
      tabs={[
        createChartTab({
          id: 'total-staked',
          label: 'Total Staked',
          component: TotalStakedChart,
          isError: chartDetails.history.isError,
          isPending: chartDetails.history.isLoading,
          props: {
            data: chartDetails.history.data ?? [],
            primaryColor: '#FB4AB9',
            lineColorClassName: cn('bg-gradient-spark-primary-2'),
          },
          timeframeOptions: {
            availableTimeframes: chartDetails.availableTimeframes,
            selectedTimeframe: chartDetails.timeframe,
            setSelectedTimeframe: chartDetails.onTimeframeChange,
          },
        }),
      ]}
    />
  )
}
